import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Centralized SEO helper. Pass per-page meta. The site defaults still live in /public/index.html.
 */
export default function SEO({
  title,
  description,
  keywords,
  image,
  url,
  type = "website",
  jsonLd,
}) {
  const fullTitle = title
    ? `${title} | M NAIEF Brindes Personalizados`
    : "M NAIEF Brindes Personalizados | Sacolas de Algodão, Sacolas TNT, Squeezes & Brindes Corporativos";
  const fullUrl = url
    ? (url.startsWith("http") ? url : `https://mnaief.com.br${url}`)
    : "https://mnaief.com.br/";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
